import {
  ComplianceSnapshotFragment,
  FinanceFinancialDocumentComplianceExtraFieldsConfig,
} from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { mapComplianceSnapshotEventType } from 'modules/finance/lib/complianceSnapshotUtils'

import { ComplianceSnapshotInfo } from './ComplianceSnapshotInfo'

interface ComplianceSnapshotSidepanelProps {
  complianceSnapshot: ComplianceSnapshotFragment
  complianceExtraFieldsConfigs?: FinanceFinancialDocumentComplianceExtraFieldsConfig[]
  onClose: () => void
}

const ComplianceSnapshotSidepanel = ({
  complianceSnapshot,
  complianceExtraFieldsConfigs,
  onClose,
}: ComplianceSnapshotSidepanelProps) => {
  return (
    <Sidepanel
      title={mapComplianceSnapshotEventType(complianceSnapshot.eventType)}
      width="wideXL"
      open
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
    >
      <ComplianceSnapshotInfo
        complianceSnapshot={complianceSnapshot}
        complianceExtraFieldsConfigs={complianceExtraFieldsConfigs}
      />
    </Sidepanel>
  )
}

export default ComplianceSnapshotSidepanel
